import { useEffect, useRef, useState } from 'react';

const DURATION_MS = 400;

/** Counts from `from` to `target` once, whenever `target` changes identity of
 * the run (remount or a new value). Under reduced motion the value is simply
 * the target: no frames are scheduled at all. */
export function useCountUp(target: number, from = 1): number {
  const reduced = useRef(window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  const [value, setValue] = useState(reduced.current ? target : from);

  useEffect(() => {
    if (reduced.current || target === from) {
      setValue(target);
      return;
    }
    const start = performance.now();
    let frame = requestAnimationFrame(function step(now) {
      const progress = Math.min((now - start) / DURATION_MS, 1);
      setValue(Math.round(from + (target - from) * progress));
      if (progress < 1) frame = requestAnimationFrame(step);
    });
    return () => cancelAnimationFrame(frame);
  }, [target, from]);

  return value;
}
